import { Outlet } from "react-router-dom";

import { SettingsNav } from "@/components/settings/SettingsNav";

/**
 * Settings chrome: the sectioned sub-nav beside the active page. From `md` up
 * the nav is a sticky left column; below it stacks as a pill row above the
 * content. Each page keeps its own title (card header or PageHeader), so the
 * layout adds none. Also wraps `/apps`, which is a Settings page by nav
 * placement even though its route lives outside `/settings`.
 */
export default function SettingsLayout() {
  return (
    <div className="min-w-0">
      <div className="flex min-w-0 flex-col gap-5 md:flex-row md:gap-10">
        <SettingsNav className="md:sticky md:top-4 md:w-48 md:shrink-0 md:self-start" />
        <div className="min-w-0 flex-1 space-y-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
